<script>
import api from "@/api";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import GameModal from "@/components/GameModal";
import MultiGameModal from "@/components/MultiGameModal";
import GameScoresModal from "@/components/GameScoresModal.vue";
import TournamnetBracket from "@/components/TournamnetBracket.vue";

export default {
  components: { TournamnetBracket, DataTable, Column, GameModal, MultiGameModal, GameScoresModal },
  props: ["schedule", "unscheduled", "master", "refreshSchedule"],
  data() {
    return {
      exportDialog: false,
      yourfilename: "hey",
      showOpen: false,
      printing: false,
      showFilters: window.location.href.includes("_id="),
      selectedItems: [],
      filterChoice: "team",
      editModal: false,
      scoresModal: false,
      selectedTeams: [],
      selectedSurfaces: [],
      selectedVenues: [],
      selectedDivisions: [],
      filters: {},
      columns: null,
      selectedColumns: null,
      editSelection: null,
      gameModal: false,
      conflicts: null,
      conflictDialog: false,
      activeGame: null,
      bracketDialog: false,
    };
  },
  computed: {
    scheduleSurfaces() {
      if (!this.schedule) {
        return [];
      }
      var usedDivs = [];
      this.currentSeason.venues.forEach(z => {
        z.surfaces.forEach(d => {
          usedDivs.push(d.id);
        });
      });
      return usedDivs;
    },
    filterSurfaces() {
      if (!this.schedule) {
        return [];
      }

      var results = [];

      this.schedule.surfaces.forEach(d => {
        if (
          this.scheduleSurfaces.includes(d.id) &&
          this.scheduleVenues.includes(d.venue_id) &&
          this.selectedVenues.includes(d.venue_id)
        ) {
          results.push(d);
        }
      });
      return results;
    },
    scheduleVenues() {
      if (!this.schedule) {
        return [];
      }

      var usedDivs = [];

      this.currentSeason.venues.forEach(d => {
        usedDivs.push(d.id);
      });
      return usedDivs;
    },
    filterVenues() {
      if (!this.schedule) {
        return [];
      }

      var results = [];

      this.currentSeason.venues.forEach(d => {
        results.push(d);
      });
      return results;
    },
    scheduleDivisions() {
      if (!this.schedule) {
        return [];
      }
      if (this.schedule.division) {
        return [this.schedule.division.id];
      }
      var usedDivs = [];
      this.schedule.scheduled_items.forEach(i => {
        if (i.game && !usedDivs.includes(i.game.division_id)) {
          usedDivs.push(i.game.division_id);
        }
      });
      if (this.master || usedDivs.length == 0) {
        console.log("MASTER DIVS");
        usedDivs = [];
        this.currentSeason.divisions.forEach(d => {
          usedDivs.push(d.id);
        });
      }
      return usedDivs;
    },
    filterDivisions() {
      console.log(this.schedule);
      if (!this.schedule) {
        return [];
      }
      if (!this.schedule.divisions) {
        return [this.schedule.division];
      }
      var results = [];
      this.schedule.divisions.forEach(d => {
        if (this.scheduleDivisions.includes(d.id)) {
          results.push(d);
        }
      });
      return results;
    },
    scheduleTeams() {
      if (!this.schedule) {
        return [];
      }

      var usedTeams = [];

      this.currentSeason.teams.forEach(d => {
        usedTeams.push(d.id);
      });
      return usedTeams;
    },
    gameTeams() {
      if (!this.schedule) {
        return [];
      }
      var results = [];
      console.log("Selected: " + this.selectedTeams);
      this.currentSeason.teams.forEach(d => {
        if (!this.selectedTeams.length || this.selectedTeams.includes(d.id)) {
          results.push(d);
        }
      });
      return results;
    },
    filterTeams() {
      if (!this.schedule) {
        return [];
      }
      var results = [];
      this.currentSeason.teams.forEach(d => {
        if (this.scheduleTeams.includes(d.id) || this.scheduleDivisions.includes(d.division_id)) {
          results.push(d);
        }
      });
      return results;
    },
    selectedIDs() {
      var ids = [];
      this.selectedItems.forEach(i => {
        ids.push(i.id);
      });
      return ids;
    },
    openTimeslots() {
      return this.schedule.open_timeslots;
    },
    halfColumns() {
      var length = this.columns.length / 2 - 1;
      var a = [];
      var b = [];

      this.columns.forEach((c, index) => {
        if (index > length) {
          b.push(c);
        } else {
          a.push(c);
        }
      });
      return {
        a: a,
        b: b,
      };
    },
    halfTeams() {
      console.log("HalfTeams", this.filterDivisions, this.filterTeams);
      var length = this.filterTeams.length / 2 - 1;
      var a = [];
      var b = [];

      this.filterTeams.forEach((c, index) => {
        if (index > length) {
          b.push(c);
        } else {
          a.push(c);
        }
      });
      return {
        a: a,
        b: b,
      };
    },
    tableItems() {
      console.log("TableItems, OTS: ", this.schedule.open_timeslots.length);
      var x = this.schedule.unscheduled_items;
      if (!this.unscheduled) {
        x = this.filterScheduleItems(
          this.schedule.scheduled_items,
          this.selectedTeams,
          this.selectedDivisions,
          this.selectedVenues,
          this.selectedSurfaces,
        );
      }
      var items = [];
      x.forEach(item => {
        // this.sayDev(item)
        if (this.unscheduled) {
          items.push({
            id: item.id,
            start: "",
            finish: "",
            home: {
              name: item.game.home.name,
              id: item.game.home.id,
              score: item.game.home_score,
              shortcode: item.game.home.shortcode,
            },
            visitor: {
              name: item.game.visitor.name,
              id: item.game.visitor.id,
              score: item.game.visitor_score,
              shortcode: item.game.visitor.shortcode,
            },
            venue: {
              name: "",
              id: "",
            },
            surface: {
              name: "",
            },
            date: "",
            time: "",
            label: "",
          });
        } else {
          items.push(this.formatItem(item));
        }
      });
      if (!this.currentUser.upgraded) {
        items.forEach((item, i) => {
          if (i % 3 == 0) {
            item.blocked = true;
            item.time = "HIDDEN";
            item.label = "HIDDEN";
            item.start = "HIDDEN";
            item.blocked = true;
            item.home.name = "HIDDEN";
            item.visitor.name = "HIDDEN";
            item.venue.name = "HIDDEN";
            item.surface.name = "HIDDEN";
          }
        });
      }
      if (this.printing) {
        items.unshift({
          id: "",
          start: "START",
          weekday: "DAY",
          finishTime: "FINISH",
          home: {
            name: "HOME",
          },
          visitor: {
            name: "VISITOR",
          },
          game_score: this.$t("game-score"),
          venue: {
            name: "VENUE",
            id: "",
          },
          surface: {
            name: "SURFACE",
          },
          date: "DATE",
          time: "START",
        });
      }
      if (!this.showOpen) {
        return items;
      }
      console.log(this.schedule);
      if (!this.unscheduled && this.openTimeslots) {
        console.log("Do open, timeslots length:", this.openTimeslots.length);
        var z = this.filterTimeslots(
          this.openTimeslots,
          this.selectedTeams,
          this.selectedDivisions,
          this.selectedVenues,
          true,
          true,
          true,
          false,
          this.selectedSurfaces,
          null,
          null,
          true,
          true,
          true,
        );
        // console.log("new", n.length)
        // var z = this.filterTimeslots(
        //   this.openTimeslots,
        //   this.selectedTeams,
        //   this.selectedDivisions,
        //   this.selectedVenues,
        //   this.selectedSurfaces,
        // );
        console.log("Result: ", z.length);
        z.forEach(timeslot => {
          items.push(this.formatTimeslot(timeslot));
        });
      }
      return items;
    },
  },
  methods: {
    doDbd() {
      this.$emit("dbd");
    },
    checkConflicts() {
      console.log("Check conflicts....");
      this.conflicts = null;
      this.conflictDialog = true;
      var season_id = this.currentSeason.id;
      var schedule_id = this.schedule.id;
      if (this.master) {
        schedule_id = "";
      }
      api.checkConflicts(schedule_id, season_id).then(response => {
        console.log(response.data);
        this.conflicts = response.data;
        // this.conflicts.formatted = {
        //   surfaces: [],
        //   teams: []
        // }
        // this.conflicts.surfaces.forEach((c)=> {
        //   // console.log(this.formatItem(c[0]))
        //   this.selectedItems.push(c[0].item.id)
        // })
        // this.$forceUpdate()
      });
    },
    teamSnapCSV() {
      var data;
      var filename = (this.schedule.name || "DiamondScheduler") + "- TeamSnap -" + new Date().toLocaleString() + ".csv";
      var skinny = [];
      this.tableItems.forEach(i => {
        console.log(i.start, i.finish);
        var x = {
          Date: this.dateToMDY(i.start),
          "Start Time": this.wrap(
            i.blocked || i.start == "HIDDEN" ? "HIDDEN" : !i.start ? "-" : this.$moment(i.start).format("LT"),
          ),
          "End Time": this.wrap(
            i.blocked || i.finish == "HIDDEN" ? "HIDDEN" : !i.finish ? "-" : this.$moment(i.finish).format("LT"),
          ),
          "Event Type": i.game ? "GAME" : "PRACTICE",
          Division:
            this.wrap(i.game && i.game.home.division ? i.game.home.division.name : "") ||
            this.wrap(i.game && i.game.visitor.division ? i.game.visitor.division.name : ""),
          "Home Team": this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.home ? i.home.name : ""),
          Location: this.wrap(
            (i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.venue ? i.venue.name : "") +
              " --- " +
              (i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.surface ? i.surface.name : ""),
          ),
        };
        if (i.game) {
          var x = {
            Date: this.dateToMDY(i.start),
            "Start Time": this.wrap(
              i.blocked || i.start == "HIDDEN" ? "HIDDEN" : !i.start ? "-" : this.$moment(i.start).format("LT"),
            ),
            "End Time": this.wrap(
              i.blocked || i.finish == "HIDDEN" ? "HIDDEN" : !i.finish ? "-" : this.$moment(i.finish).format("LT"),
            ),
            "Event Type": i.game ? "GAME" : "PRACTICE",
            Division:
              this.wrap(i.game && i.game.home.division ? i.game.home.division.name : "") ||
              this.wrap(i.game && i.game.visitor.division ? i.game.visitor.division.name : ""),
            "Home Team": this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.home ? i.home.name : ""),
            Location: this.wrap(
              (i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.venue ? i.venue.name : "") +
                " --- " +
                (i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.surface ? i.surface.name : ""),
            ),
            "Away Team": this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.visitor ? i.visitor.name : ""),
          };
        }
        skinny.push(x);
      });
      var csv = this.convertArrayOfObjectsToCSV({
        data: skinny,
      });
      console.log("GOt CSV", csv);
      if (csv == null) return;

      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      var link = document.createElement("a");
      document.body.appendChild(link);
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
      document.body.removeChild(link);
      console.log("CLICKED!");
      this.exportDialog = false;
    },
    doBalances() {
      this.$emit("dobalances");
    },
    debug() {
      console.log(this.selectedItems);
      var ids = [];
      this.selectedItems.forEach(i => {
        ids.push(i.id);
      });
      console.log(ids);
    },
    closeModals() {
      this.editModal = false;
      this.scoresModal = false;
      this.gameModal = false;
    },
    startRemove(shouldDelete) {
      console.log("StartRemove " + this.selectedItems.length + ", Delete:" + shouldDelete);
      console.log(this.selectedIDs);
      if (shouldDelete) {
        var x = window.confirm(this.$t("are-you-sure-you-want-to-delete-these-items-this-cannot-be-undone"));
        if (x) {
          api
            .deleteScheduleItems({
              items: this.selectedIDs,
            })
            .then(response => {
              this.makeToast("success", this.$t("Toast.deleted-items"));
              this.$emit("refresh");
              this.selectedItems = [];
            })
            .catch(e => {
              console.log(e);
              this.makeToast("error", this.$t("Toast.could-not-delete-items"));
            });
        }
      } else {
        var x = window.confirm(this.$t("are-you-sure-you-want-to-unschedule-these-games-the-pairings"));
        if (x) {
          api
            .unscheduleItems({
              items: this.selectedIDs,
            })
            .then(response => {
              console.log(response);
              this.selectedItems = [];
              this.makeToast("success", this.$t("Toast.unscheduled-game"));
              // this.selectedItems.forEach((i)=> {
              //   this.$emit("unschedulegame", i.id);
              // })
              this.$emit("refresh");
            })
            .catch(e => {
              console.log(e);
              this.makeToast("error", this.$t("Toast.could-not-complete-action"), this.input.id);
            });
        }
      }
    },
    formatTimeslot(item) {
      var timeslot = item;
      var label = "";
      if (timeslot.surface && timeslot.venue) {
        label =
          this.$t("open-timeslot") +
          this.$moment(timeslot.start).format("MM-DD-YY") +
          " " +
          this.$moment(timeslot.start).format("LT") +
          " at " +
          timeslot.venue.name +
          " (" +
          timeslot.surface.name +
          ")";
      } else {
        timeslot = item.timeslot;
      }
      return {
        open: true,
        id: timeslot.id,
        timeslot: timeslot,
        start: timeslot.start,
        finish: timeslot.finish,
        home: {
          name: "-",
          id: "",
          score: "-",
        },
        visitor: {
          name: "-",
          id: "",
          score: "-",
        },
        venue: timeslot.venue,
        surface: timeslot.surface,
        week: this.$moment(timeslot.start).isoWeek(),
        date: this.$moment(timeslot.start).format("MM-DD-YY"),
        weekday: this.$moment(timeslot.start).format("dddd"),
        // date: new Date(timeslot.start),
        sortDate: new Date(timeslot.start).getTime(),
        time: this.$moment(timeslot.start).format("LT"),
        label: label,
      };
    },
    swapTimeslots() {
      console.log("Swap! ", this.selectedItems);
      var ids = this.selectedIDs;
      api
        .swapScheduleItems({
          items: ids,
        })
        .then(response => {
          console.log(response);
          this.makeToast("success", this.$t("Toast.swapped-timeslots"));
          var updates = ids;
          this.selectedItems.forEach(i => {
            if (i.timeslot.id) {
              updates.push(i.timeslot.id);
            }
          });
          console.log("Do Updates: ", updates);
          this.$emit("update", updates);
          this.selectedItems = [];
          // this.refresh();
        })
        .catch(e => {
          this.makeToast("error", this.$t("Toast.could-not-complete-action"));
          console.log(e);
        });
    },
    getOpenTimeslots() {
      console.log("GetOpenTimeslots!");
      this.$emit("openslots");
    },
    toggleShowOpen() {
      var x = !this.showOpen;
      console.log("Toggle Open to " + x);
      this.showOpen = x;
      if (this.showOpen) {
        this.getOpenTimeslots();
      }
    },
    getIDs(group) {
      var results = [];
      if (!group) {
        return [];
      }
      group.forEach(g => {
        results.push(g.id);
      });
      return results;
    },
    toggleTeams() {
      if (this.selectedTeams.length) {
        this.selectedTeams = [];
      } else {
        console.log("all", this.getIDs(this.schedule.teams));
        this.selectedTeams = this.getIDs(this.schedule.teams);
      }
      console.log(this.selectedTeams.length);
    },
    toggleSurfaces() {
      if (this.selectedSurfaces.length) {
        this.selectedSurfaces = [];
      } else {
        console.log("all", this.getIDs(this.schedule.surfaces));
        this.selectedSurfaces = this.getIDs(this.schedule.surfaces);
      }
      console.log(this.selectedTeams.length);
    },
    toggleDivisions() {
      if (this.selectedDivisions.length) {
        this.selectedDivisions = [];
      } else {
        console.log("all", this.getIDs(this.schedule.divisions));
        this.selectedDivisions = this.getIDs(this.schedule.divisions);
      }
      console.log(this.selectedDivisions.length);
    },
    toggleVenues() {
      if (this.selectedVenues.length) {
        this.selectedVenues = [];
      } else {
        this.selectedVenues = this.getIDs(this.currentSeason.venues);
      }
      console.log(this.selectedVenues.length);
    },
    gameCreated(item) {
      console.log("gameCreated", item);
      // this.$emit("gamecreated", this.formatItem(item));
      this.clearModal();
      this.refresh();
    },
    gameDeleted(id) {
      this.$emit("gameupdated", id, false);
      this.clearModal();
    },
    gameUnscheduled(id) {
      this.$emit("gameupdated", id, true);
      this.clearModal();
    },
    clearModal() {
      console.log("Clear Modal");
      this.selectedItems = [];
      this.activeGame = null;
      this.gameModal = false;
      setTimeout(() => {
        this.selectedVenues = this.scheduleVenues;
        this.selectedSurfaces = this.scheduleSurfaces;
      }, 50);
      setTimeout(() => {
        this.selectedVenues = this.scheduleVenues;
        this.selectedSurfaces = this.scheduleSurfaces;
      }, 1000);
      setTimeout(() => {
        this.selectedVenues = this.scheduleVenues;
        this.selectedSurfaces = this.scheduleSurfaces;
      }, 2000);
      setTimeout(() => {
        this.selectedVenues = this.scheduleVenues;
        this.selectedSurfaces = this.scheduleSurfaces;
      }, 3000);
    },
    getTotalGameScore(game) {
      const home_score = game.home_score;
      const visitor_score = game.visitor_score;

      let result = "";
      if (visitor_score !== null && home_score !== null) {
        result = `${visitor_score}-${home_score}`;
        if (game.overtime) result += " (OT)";
      }
      return result;
    },
    formatItem(item) {
      var x = {
        id: item.id,
        schedule_id: item.schedule_id,
        open: false,
        timeslot: item.timeslot,
        start: item.timeslot.start,
        finish: item.timeslot.finish,
        home: {
          name: item.game.home.name || "TBD",
          id: item.game.home.id,
          score: item.game.home_score,
          division: item.game.home.division,
          shortcode: item.game.home.shortcode,
        },
        home_score: item.game.home_score || 0,
        visitor: {
          name: item.game && item.game.is_practice ? "PRACTICE" : item.game.visitor.name || "TBD",
          id: item.game.visitor.id,
          score: item.game.visitor_score,
          division: item.game.visitor.division,
          shortcode: item.game.visitor.shortcode,
        },
        visitor_score: item.game.visitor_score || 0,
        game_score: this.getTotalGameScore(item.game),
        overtime: item.game.overtime,
        venue: item.timeslot.venue,
        surface: item.timeslot.surface,
        game: item.game,
        weekday: this.$moment(item.timeslot.start).format("dddd"),
        week: this.$moment(item.timeslot.start).isoWeek(),
        date: this.$moment(item.timeslot.start).format("MM-DD-YY"),
        updated_at: this.$moment(item.updated_at)
          .fromNow()
          .toString()
          .replace(" ago", ""),
        update_sort: new Date(item.updated_at).getTime(),
        sortDate: new Date(item.timeslot.start).getTime(),
        time: this.$moment(item.timeslot.start).format("LT"),
        finishTime: this.$moment(item.timeslot.finish).format("LT"),
        label:
          item.game.visitor.name +
          " at " +
          item.game.home.name +
          ": " +
          this.$moment(item.timeslot.start).format("MM-DD-YY") +
          " " +
          this.$moment(item.timeslot.start).format("LT") +
          " at " +
          item.timeslot.venue.name +
          " (" +
          item.timeslot.surface.name +
          ")",
      };
      return x;
    },
    downloadArbiterCSV: function() {
      // console.log("DO CSV", this.tableItems);
      console.log(
        "Sport ID: ",
        this.schedule.sport,
        this.schedule.se_sport_id,
        this.getSportFromID(this.schedule.se_sport_id),
      );
      // return
      var data;
      var filename = "arbiter_" + (this.schedule.name || "DiamondScheduler -	") + new Date().toLocaleString() + ".csv";
      var skinny = [];
      this.tableItems.forEach((i, index) => {
        // console.log(i.start, i.finish)
        skinny.push({
          Date: this.wrap(this.$moment(i.start).format("L")),
          Day: this.wrap(i.weekday),
          Time: this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : !i.start ? "-" : this.$moment(i.start).format("LT")),
          "Game ID": index + 1,
          Sport: this.wrap(this.schedule.sport || this.getSportFromID(this.schedule.se_sport_id) || ""),
          Level: this.wrap(this.schedule.division
            ? this.schedule.division.name
            : (this.currentSeason && this.currentSeason.name) || ""),
          "Home Team": this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.home ? i.home.name : ""),
          "Away Team": this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.visitor ? i.visitor.name : ""),
          Site: this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.venue ? i.venue.name : ""),
          Subsite: this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.surface ? i.surface.name : ""),
          "Bill To": "",
        });
      });
      var csv = this.convertArrayOfObjectsToCSV({
        data: skinny,
      });
      // console.log("GOt CSV", csv);
      if (csv == null) return;

      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      var link = document.createElement("a");
      document.body.appendChild(link);
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
      document.body.removeChild(link);
      console.log("CLICKED!");
      this.exportDialog = false;
    },
    downloadSombreroCSV: function() {
      // console.log("DO CSV", this.tableItems);
      console.log(
        "Sport ID: ",
        this.schedule.sport,
        this.schedule.se_sport_id,
        this.getSportFromID(this.schedule.se_sport_id),
      );
      // return
      var data;
      var filename =
        "Sombrero - " + (this.schedule.name || " - DiamondScheduler - ") + new Date().toLocaleString() + ".csv";
      var skinny = [];
      this.tableItems.forEach((i, index) => {
        // console.log(i.start, i.finish)
        var ht = this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.home ? i.home.name : "");
        if (this.schedule && this.schedule.is_practice) {
          skinny.push({
            SortOrder: index + 1,
            RoundNo: index + 1,
            Team: ht,
            MatchDate: this.wrap(this.$moment(i.start).format("L")),
            StartTime: this.wrap(
              i.blocked || i.start == "HIDDEN" ? "HIDDEN" : !i.start ? "-" : this.$moment(i.start).format("LT"),
            ),
            EndTime: this.wrap(
              i.blocked || i.finish == "HIDDEN" ? "HIDDEN" : !i.finish ? "-" : this.$moment(i.finish).format("LT"),
            ),
            Location: this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.venue ? i.venue.name : ""),
            Field: this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.surface ? i.surface.name : ""),
          });
        } else {
          skinny.push({
            SortOrder: index + 1,
            RoundNo: index + 1,
            HomeTeam: ht,
            AwayTeam: i.game.is_practice
              ? ht
              : i.blocked || i.start == "HIDDEN"
              ? "HIDDEN"
              : i.visitor
              ? this.wrap(i.visitor.name)
              : "",
            MatchDate: this.wrap(this.$moment(i.start).format("L")),
            StartTime: this.wrap(
              i.blocked || i.start == "HIDDEN" ? "HIDDEN" : !i.start ? "-" : this.$moment(i.start).format("LT"),
            ),
            EndTime: this.wrap(
              i.blocked || i.finish == "HIDDEN" ? "HIDDEN" : !i.finish ? "-" : this.$moment(i.finish).format("LT"),
            ),
            Location: this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.venue ? i.venue.name : ""),
            Field: this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.surface ? i.surface.name : ""),
          });
        }
      });
      var csv = this.convertArrayOfObjectsToCSV({
        data: skinny,
      });
      // console.log("GOt CSV", csv);
      if (csv == null) return;

      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      var link = document.createElement("a");
      document.body.appendChild(link);
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
      document.body.removeChild(link);
      console.log("CLICKED!");
      this.exportDialog = false;
    },
    pointstreakCSV: function() {
      var data;
      var filename =
        "PointStreak - " + (this.schedule.name || " - DiamondScheduler - ") + new Date().toLocaleString() + ".csv";
      var skinny = [];
      this.tableItems.forEach((i, index) => {
        // console.log(i.start, i.finish)
        var ht = this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.home ? i.home.name : "");
        skinny.push({
          "Game Number": index + 1,
          "Schedule Date": this.wrap(this.$moment(i.start).format("L")),
          Time: this.wrap(
            i.blocked || i.start == "HIDDEN" ? "HIDDEN" : !i.start ? "-" : this.$moment(i.start).format("HH:mm"),
          ),
          "Home Team": ht,
          "Away Team": i.game.is_practice
            ? ht
            : i.blocked || i.start == "HIDDEN"
            ? "HIDDEN"
            : i.visitor
            ? this.wrap(i.visitor.name)
            : "",
          Rink: this.wrap(
            i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.venue ? i.venue.name + " @ " + i.surface.name : "",
          ),
        });
      });
      var csv = this.convertArrayOfObjectsToCSV({
        data: skinny,
      });
      // console.log("GOt CSV", csv);
      if (csv == null) return;

      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      var link = document.createElement("a");
      document.body.appendChild(link);
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
      document.body.removeChild(link);
      console.log("CLICKED!");
      this.exportDialog = false;
    },
    downloadLACSV: function() {
      // console.log("DO CSV", this.tableItems);
      console.log(
        "Sport ID: ",
        this.schedule.sport,
        this.schedule.se_sport_id,
        this.getSportFromID(this.schedule.se_sport_id),
      );
      // return
      var data;
      var filename =
        "LeagueAthletics - " + (this.schedule.name || " - DiamondScheduler - ") + new Date().toLocaleString() + ".csv";
      var skinny = [];
      this.tableItems.forEach((i, index) => {
        // console.log(i.start, i.finish)
        var ht = this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.home ? i.home.name : "");
        skinny.push({
          "Club ID": "",
          Date: this.wrap(this.$moment(i.start).format("L")),
          Start: this.wrap(
            i.blocked || i.start == "HIDDEN" ? "HIDDEN" : !i.start ? "-" : this.$moment(i.start).format("LT"),
          ),
          Finish: this.wrap(
            i.blocked || i.finish == "HIDDEN" ? "HIDDEN" : !i.finish ? "-" : this.$moment(i.finish).format("LT"),
          ),
          Team: ht,
          Opponent: i.game.is_practice
            ? ht
            : i.blocked || i.start == "HIDDEN"
            ? "HIDDEN"
            : i.visitor
            ? this.wrap(i.visitor.name)
            : "",
          Venue: this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.venue ? i.venue.name : ""),
          Surface: this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.surface ? i.surface.name : ""),
          Type: i.game.is_practice ? "Practice" : "Game",
          Note: "",
          "N/A": "",
          For: "",
          Against: "",
          "DB ID": "",
          Ofcl: "",
          "Write Up": "",
        });
      });
      var csv = this.convertArrayOfObjectsToCSV({
        data: skinny,
      });
      // console.log("GOt CSV", csv);
      if (csv == null) return;

      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      var link = document.createElement("a");
      document.body.appendChild(link);
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
      document.body.removeChild(link);
      console.log("CLICKED!");
      this.exportDialog = false;
    },
    getBlankObject() {
      return {
        DATE: "",
        DAY: "",
        START_TIME: "",
        END_TIME: "",
        VISITOR_TEAM: "",
        HOME_TEAM: "",
        VENUE: "",
        SURFACE: "",
        GAME_SCORE: "",
        EVENT_TYPE: "",
        VISITOR_DIVISION: "",
        HOME_DIVISION: "",
        HOME_TEAM_CODE: "",
        VISITOR_TEAM_CODE: "",
        HOME_DIVISION_CODE: "",
        VISITOR_DIVISION_CODE: "",
        HOME_ID: "",
        VISITOR_ID: "",
        HOME_ABBREV: "",
        VISITOR_ABBREV: "",
        HOME_DIVISION_ID: "",
        VISITOR_DIVISION_ID: "",
        HOME_DIVISION_ABBREV: "",
        VISITOR_DIVISION_ABBREV: "",
        SCHEDULE_ITEM_ID: "",
        SCHEDULE_ID: "",
        VENUE_ID: "",
        VENUE_ABBREV: "",
        SURFACE_ID: "",
        HOME_SE_ID: "",
        VISITOR_SE_ID: "",
        HOME_SE_MAPPING_CODE: "",
        VISITOR_SE_MAPPING_CODE: "",
        HOME_DIVISION_SE_ID: "",
        VISITOR_DIVISION_SE_ID: "",
        HOME_DIVISION_SE_MAPPING_CODE: "",
        VISITOR_DIVISION_SE_MAPPING_CODE: "",
        SEASON_ID: "",
        LEAGUE_ID: "",
        SE_SEASON_ID: "",
        SE_SUBSEASON_ID: "",
        UNIX_TIMESTAMP: "",
      };
    },
    perTeamCSV() {
      console.log(this.scheduleTeams);

      var data;
      var filename = (this.schedule.name || "DiamondScheduler - ") + new Date().toLocaleString() + ".csv";
      var skinny = [];

      var usedTeams = [];
      this.schedule.scheduled_items.forEach(i => {
        var g = i.game;
        if (g) {
          if (!usedTeams.includes(g.home_id)) {
            usedTeams.push(g.home_id);
          }
          if (!usedTeams.includes(g.visitor_id)) {
            usedTeams.push(g.visitor_id);
          }
        }
      });
      if (this.master || usedTeams.length == 0) {
        this.currentSeason.teams.forEach(d => {
          usedTeams.push(d.id);
        });
      }
      usedTeams.forEach(t => {
        skinny.push(this.getBlankObject());
        var x = this.getBlankObject();
        this.currentSeason.teams.forEach(z => {
          if (z.id == t) {
            x.DATE = z.name;
          }
        });
        skinny.push(x);
        console.log("Do team " + t);
        // skinny.push({})
        this.tableItems.forEach(i => {
          if (i.game && (i.game.home_id == t || i.game.visitor_id == t)) {
            console.log("ya");
            skinny.push(this.wrapTableItem(i));
          }
        });
      });
      console.log("Skinny!");
      console.log(skinny);
      var csv = this.convertArrayOfObjectsToCSV({
        data: skinny,
      });
      console.log("GOt CSV", csv);
      if (csv == null) return;

      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      var link = document.createElement("a");
      document.body.appendChild(link);
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
      document.body.removeChild(link);
      console.log("CLICKED!");
      this.exportDialog = false;
    },
    laWrapItem(i) {
      console.log(i);
      var ht = this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.home ? i.home.name : "");
      var hht = i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.home ? i.home.name : "";
      var vt = i.game.is_practice
        ? ht
        : this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.visitor ? i.visitor.name : "");
      var vvt = i.game.is_practice
        ? hht
        : i.blocked || i.start == "HIDDEN"
        ? "HIDDEN"
        : i.visitor
        ? i.visitor.name
        : "";
      var title = this.wrap(vvt + " @ " + hht);
      var description = this.wrap(vvt + " @ " + hht + " at " + i.venue.name + " (" + i.surface.name + ")");
      if (i.game.is_practice) {
        title = this.wrap("Practice: " + vvt);
        description = this.wrap(vvt + this.$t("practice") + " at " + i.venue.name + " (" + i.surface.name + ")");
      }
      var location = i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.venue ? i.venue.name : "";
      var surface = i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.surface ? i.surface.name : "";
      location += " --- " + surface;
      return {
        SUB_PROGRAM: "",
        HOME_TEAM: hht,
        AWAY_TEAM: vvt,
        DATE: this.dateToMDY(i.start),
        START_TIME: this.wrap(
          i.blocked || i.start == "HIDDEN" ? "HIDDEN" : !i.start ? "-" : this.$moment(i.start).format("HH:mm"),
        ),
        END_TIME: this.wrap(
          i.blocked || i.finish == "HIDDEN" ? "HIDDEN" : !i.finish ? "-" : this.$moment(i.finish).format("HH:mm"),
        ),
        LOCATION: this.wrap(i.venue.name),
        SUB_LOCATION: this.wrap(i.surface.name),
        TYPE: "REGULAR SEASON",
        NOTES: "",
      };
    },
    goWrapTableItem(i) {
      console.log(i);
      var ht = this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.home ? i.home.name : "");
      var hht = i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.home ? i.home.name : "";
      var vt = i.game.is_practice
        ? ht
        : this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.visitor ? i.visitor.name : "");
      var vvt = i.game.is_practice
        ? hht
        : i.blocked || i.start == "HIDDEN"
        ? "HIDDEN"
        : i.visitor
        ? i.visitor.name
        : "";
      var title = this.wrap(vvt + " @ " + hht);
      var description = this.wrap(vvt + " @ " + hht + " at " + i.venue.name + " (" + i.surface.name + ")");
      if (i.game.is_practice) {
        title = this.wrap("Practice: " + vvt);
        description = this.wrap(vvt + this.$t("practice") + " at " + i.venue.name + " (" + i.surface.name + ")");
      }
      var location = i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.venue ? i.venue.name : "";
      var surface = i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.surface ? i.surface.name : "";
      location += " --- " + surface;
      return {
        "Home Team": hht,
        "Visitor Team": vvt,
        "Date (MM/DD/YYYY)": this.dateToMDY(i.start),
        "Start Time (HH:MM AA)": this.wrap(
          i.blocked || i.start == "HIDDEN" ? "HIDDEN" : !i.start ? "-" : this.$moment(i.start).format("hh:mm a"),
        ),
        "Duration (minutes)": this.$moment.duration(this.$moment(i.finish).diff(this.$moment(i.start))).asMinutes(),
        Details: "",
        "Show Details (Y/N)": "Y",
        "League Name": this.schedule && this.schedule.division ? this.schedule.division.name : this.currentLeague.name,
        "Practice Type (Shared or Full)": "",
        "Schedule Name": (this.schedule && this.schedule.name) || "Master Schedule",
        Venue: this.wrap(location),
      };
    },
    rampWrap(i) {
      let location = this.wrap(i.blocked ? "HIDDEN" : i.venue.name);
      const surface = i.blocked ? "HIDDEN" : i.surface.name;
      location += " " + surface;
      const completed = i.home.score !== null && i.visitor.score !== null;
      const overtime = i.game.overtime ? "Yes" : "No";
      const homeScore = i.home.score !== null ? `${i.home.score}` : "";
      const visitorScore = i.visitor.score !== null ? `${i.visitor.score}` : "";

      return {
        GameNumber: "",
        Season: this.wrap(i.blocked ? "HIDDEN" : this.currentSeason.name),
        "Game Type": "",
        Category: this.wrap(i.blocked ? "HIDDEN" : this.currentLeague.name),
        "Home Division": this.wrap(i.blocked ? "HIDDEN" : i.home.division.name),
        "Visitor Division": this.wrap(i.blocked ? "HIDDEN" : i.visitor.division.name),
        "Home SubDivision": "",
        "Visitor SubDivision": "",
        Date: this.wrap(i.blocked ? "HIDDEN" : this.dateToMDY(i.date)),
        Start: this.$moment(i.start).format("hh:mm A"),
        End: this.$moment(i.finish).format("hh:mm A"),
        Field: location,
        FieldAbbr: "",
        FieldCity: "",
        "Home Team": this.wrap(i.blocked ? "HIDDEN" : i.home.name),
        "Visitor Team": this.wrap(i.blocked ? "HIDDEN" : i.visitor.name),
        "Home Team Abbr": this.wrap(i.blocked ? "HIDDEN" : i.home.shortcode),
        "Visitor Team Abbr": this.wrap(i.blocked ? "HIDDEN" : i.visitor.shortcode),
        "Home Team Display": "",
        "Visitor Team Display": "",
        "Home Score": this.wrap(i.blocked ? "HIDDEN" : homeScore),
        "Visitor Score": this.wrap(i.blocked ? "HIDDEN" : visitorScore),
        Completed: completed ? "Yes" : "No",
        OT: this.wrap(i.blocked ? "HIDDEN" : overtime),
        SO: "",
        Notes: "",
      };
    },
    seSeasonManagementWrap(i) {
      const date = this.wrap(i.blocked ? "HIDDEN" : this.dateToMDY(i.date));
      const time = this.wrap(i.blocked ? "HIDDEN" : i.time);

      const start = this.$moment(i.start);
      const finish = this.$moment(i.finish);
      const duration = i.blocked ? "HIDDEN" : this.$moment.duration(finish.diff(start)).asMinutes();

      const homeTeam = i.blocked ? "HIDDEN" : i.home.name;
      const homeTeamScore = this.wrap(i.blocked ? "HIDDEN" : i.home.score);
      const awayTeam = i.blocked ? "HIDDEN" : i.game.is_practice ? i.home.name : i.visitor.name;

      const awayTeamScore = this.wrap(i.blocked ? "HIDDEN" : i.visitor.score);
      const divisionName = i.blocked ? "HIDDEN" : i.home.division.name;

      let location = i.blocked ? "HIDDEN" : i.venue.name;
      const surface = i.blocked ? "HIDDEN" : i.surface.name;
      location += " > " + surface;
      return {
        "Event Type": i.game.is_practice ? "event" : "game",
        "Event Name (Events Only)": i.game.is_practice ? "Practice" : "",
        "Description (Events Only)": "",
        "Date": date,
        "Start Time": this.$moment(i.start).format("hh:mm A"),
        "End Time": this.$moment(i.finish).format("hh:mm A"),
        "Duration (minutes)": duration,
        "All Day Event (Events Only)": "No",
        "Home Team": this.wrap(divisionName + " > " + homeTeam),
        "Away Team": this.wrap(divisionName + " > " + awayTeam),
        "Teams (Events Only)": this.wrap(i.game.is_practice ? divisionName + " > " +homeTeam + " | " + divisionName + " > " + awayTeam : ""),
        "Venue": this.wrap(location),
        "Status": "Scheduled",
      };
    },
    seWrapTableItem(i) {
      console.log(i);
      var ht = this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.home ? i.home.name : "");
      var hht = i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.home ? i.home.name : "";
      var vt = i.game.is_practice
        ? ht
        : this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.visitor ? i.visitor.name : "");
      var vvt = i.game.is_practice
        ? hht
        : i.blocked || i.start == "HIDDEN"
        ? "HIDDEN"
        : i.visitor
        ? i.visitor.name
        : "";
      var title = this.wrap(vvt + " @ " + hht);
      var description = this.wrap(vvt + " @ " + hht + " at " + i.venue.name + " (" + i.surface.name + ")");
      if (i.game.is_practice) {
        title = this.wrap("Practice: " + vvt);
        description = this.wrap(vvt + " Practice" + " at " + i.venue.name + " (" + i.surface.name + ")");
      }
      var location = i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.venue ? i.venue.name : "";
      var surface = i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.surface ? i.surface.name : "";
      location += " --- " + surface;
      return {
        Start_Date: this.dateToMDY(i.start),
        Start_Time: this.wrap(
          i.blocked || i.start == "HIDDEN" ? "HIDDEN" : !i.start ? "-" : this.$moment(i.start).format("HH:mm"),
        ),
        End_Date: this.dateToMDY(i.finish),
        End_Time: this.wrap(
          i.blocked || i.finish == "HIDDEN" ? "HIDDEN" : !i.finish ? "-" : this.$moment(i.finish).format("HH:mm"),
        ),
        Title: title,
        Description: description,
        Location: this.wrap(location),
        Location_URL: this.wrap((i.venue && i.venue.address && i.venue.address.link) || ""),
        Location_Details: this.wrap(i.venue.notes),
        All_Day_Event: false,
        Event_Type: i.game.is_practice ? "PRACTICE" : "GAME",
        Tags: "",
        Team1_ID: (i.game && i.game.home && i.game.home.se_mapping_code) || "",
        Team1_Division_ID: (i.game && i.game.home && i.game.home.division.se_mapping_code) || "",
        Team1_Is_Home: true,
        Team2_ID: (i.game && i.game.visitor && i.game.visitor.se_mapping_code) || "",
        Team2_Division_ID: (i.game && i.game.visitor && i.game.visitor.division.se_mapping_code) || "",
        Team2_Name: i.game && i.game.visitor && i.game.visitor.name,
        Custom_Opponent: "",
        Event_ID: "",
        Game_ID: "",
        Affects_Standings: "1",
        Points_Win: "",
        Points_Loss: "",
        Points_Tie: "",
        Points_OT_Win: "",
        Points_OT_Loss: "",
        Division_Override: "",
      };
    },
    leagueAppsCSV: function() {
      // console.log("DO CSV", this.tableItems);
      var data;
      var filename = (this.schedule.name || "DiamondScheduler - ") + new Date().toLocaleString() + ".csv";
      var skinny = [];
      this.tableItems.forEach(i => {
        console.log(i);
        skinny.push(this.laWrapItem(i));
      });
      var csv = this.convertArrayOfObjectsToCSV({
        data: skinny,
      });
      console.log("GOt CSV", csv);
      if (csv == null) return;

      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      var link = document.createElement("a");
      document.body.appendChild(link);
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
      document.body.removeChild(link);
      console.log("CLICKED!");
      this.exportDialog = false;
    },
    rampCSV: function() {
      let skinny = [];
      this.tableItems.forEach(i => skinny.push(this.rampWrap(i)));

      let csv = this.convertArrayOfObjectsToCSV({ data: skinny });
      if (csv == null) return;
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }

      const data = encodeURI(csv);
      const link = document.createElement("a");
      const filename = this.schedule.name + " - RAMP – " + new Date().toLocaleString() + ".csv";
      document.body.appendChild(link);
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
      document.body.removeChild(link);

      this.exportDialog = false;
    },
    seSeasonManagement: function() {
      const filename = (this.schedule.name || "SE Season Management") + " - " + new Date().toLocaleString() + ".csv";

      let skinny = [];
      this.tableItems.forEach(i => skinny.push(this.seSeasonManagementWrap(i)));

      let csv = this.convertArrayOfObjectsToCSV({ data: skinny });
      if (csv == null) return;
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }

      const data = encodeURI(csv);
      const link = document.createElement("a");
      document.body.appendChild(link);
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
      document.body.removeChild(link);

      this.exportDialog = false;
    },
    SeCSV: function() {
      // console.log("DO CSV", this.tableItems);
      var data;
      var filename = (this.schedule.name || "DiamondScheduler - ") + new Date().toLocaleString() + ".csv";
      var skinny = [];
      this.tableItems.forEach(i => {
        console.log(i);
        skinny.push(this.seWrapTableItem(i));
      });
      var csv = this.convertArrayOfObjectsToCSV({
        data: skinny,
      });
      console.log("GOt CSV", csv);
      if (csv == null) return;

      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      var link = document.createElement("a");
      document.body.appendChild(link);
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
      document.body.removeChild(link);
      console.log("CLICKED!");
      this.exportDialog = false;
    },
    goCSV: function() {
      // console.log("DO CSV", this.tableItems);
      var data;
      var filename = (this.schedule.name || "DiamondScheduler - ") + new Date().toLocaleString() + ".csv";
      var skinny = [];
      this.tableItems.forEach(i => {
        console.log(i);
        skinny.push(this.goWrapTableItem(i));
      });
      var csv = this.convertArrayOfObjectsToCSV({
        data: skinny,
      });
      console.log("GOt CSV", csv);
      if (csv == null) return;

      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      var link = document.createElement("a");
      document.body.appendChild(link);
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
      document.body.removeChild(link);
      console.log("CLICKED!");
      this.exportDialog = false;
    },
    wrapTableItem(i) {
      var ht = this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.home ? i.home.name : "");
      var vt =
        i.game && i.game.is_practice
          ? ht
          : this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.visitor ? i.visitor.name : "");
      return {
        DATE: this.dateToMDY(i.start),
        DAY: this.wrap(i.weekday),
        START_TIME: this.wrap(
          i.blocked || i.start == "HIDDEN" ? "HIDDEN" : !i.start ? "-" : this.$moment(i.start).format("LT"),
        ),
        END_TIME: this.wrap(
          i.blocked || i.finish == "HIDDEN" ? "HIDDEN" : !i.finish ? "-" : this.$moment(i.finish).format("LT"),
        ),
        VISITOR_TEAM: vt,
        HOME_TEAM: ht,
        VENUE: this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.venue ? i.venue.name : ""),
        SURFACE: this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.surface ? i.surface.name : ""),
        GAME_SCORE: this.wrap(i.blocked || i.start == "HIDDEN" ? "HIDDEN" : i.game_score),
        EVENT_TYPE: i.game ? (i.game.is_practice ? "Practice" : "Game") : "Timeslot",
        VISITOR_DIVISION: this.wrap(i.game && i.game.visitor.division ? i.game.visitor.division.name : ""),
        HOME_DIVISION: this.wrap(i.game && i.game.home.division ? i.game.home.division.name : ""),
        HOME_TEAM_CODE: this.wrap((i.game && i.game.home && i.game.home.longcode) || ""),
        VISITOR_TEAM_CODE: this.wrap((i.game && i.game.visitor && i.game.visitor.longcode) || ""),
        HOME_DIVISION_CODE: this.wrap((i.game && i.game.home && i.game.home.division && i.game.home.division.longcode) || ""),
        VISITOR_DIVISION_CODE: this.wrap((i.game && i.game.visitor && i.game.visitor.division && i.game.visitor.division.longcode) || ""),
        HOME_ID: this.wrap((i.game && i.game.home && i.game.home.id) || ""),
        VISITOR_ID: this.wrap((i.game && i.game.visitor && i.game.visitor.id) || ""),
        HOME_ABBREV: this.wrap((i.game && i.game.home && i.game.home.shortcode) || ""),
        VISITOR_ABBREV: this.wrap((i.game && i.game.visitor && i.game.visitor.shortcode) || ""),
        HOME_DIVISION_ID: this.wrap((i.game && i.game.home && i.game.home.division_id) || ""),
        VISITOR_DIVISION_ID: this.wrap((i.game && i.game.visitor && i.game.visitor.division_id) || ""),
        HOME_DIVISION_ABBREV: this.wrap((i.game && i.game.home && i.game.home.division && i.game.home.division.shortcode) || ""),
        VISITOR_DIVISION_ABBREV: this.wrap((i.game && i.game.visitor && i.game.visitor.division && i.game.visitor.division.shortcode) || ""),
        SCHEDULE_ITEM_ID: this.wrap(i.id),
        SCHEDULE_ID: this.wrap(i.schedule_id),
        VENUE_ID: this.wrap((i.venue && i.venue.id) || ""),
        VENUE_ABBREV: this.wrap((i.venue && i.venue.shortcode) || ""),
        SURFACE_ID: this.wrap((i.surface && i.surface.id) || ""),
        HOME_SE_ID: this.wrap((i.game && i.game.home && i.game.home.se_id) || ""),
        VISITOR_SE_ID: this.wrap((i.game && i.game.visitor && i.game.visitor.se_id) || ""),
        HOME_SE_MAPPING_CODE: this.wrap((i.game && i.game.home && i.game.home.se_mapping_code) || ""),
        VISITOR_SE_MAPPING_CODE: this.wrap((i.game && i.game.visitor && i.game.visitor.se_mapping_code) || ""),
        HOME_DIVISION_SE_ID: this.wrap((i.game && i.game.home && i.game.home.division && i.game.home.division.se_id) || ""),
        VISITOR_DIVISION_SE_ID: this.wrap((i.game && i.game.home && i.game.visitor.division && i.game.visitor.division.se_id) || ""),
        HOME_DIVISION_SE_MAPPING_CODE: this.wrap((i.game && i.game.home && i.game.home.division && i.game.home.division.se_mapping_code) || ""),
        VISITOR_DIVISION_SE_MAPPING_CODE: this.wrap(
          (i.game && i.game.visitor && i.game.visitor.division && i.game.visitor.division.se_mapping_code) || "",
        ),
        SEASON_ID: this.wrap((this.currentSeason && this.currentSeason.id) || ""),
        LEAGUE_ID: this.wrap((this.currentLeague && this.currentLeague.id) || ""),
        SE_SEASON_ID: this.wrap((this.currentSeason && this.currentSeason.se_id) || ""),
        SE_SUBSEASON_ID: this.wrap((this.currentSeason && this.currentSeason.se_subseason_id) || ""),
        UNIX_TIMESTAMP: this.wrap(new Date(i.start).getTime() / 1000),
      };
    },
    downloadCSV: function() {
      // console.log("DO CSV", this.tableItems);
      var data;
      var filename = (this.schedule.name || "DiamondScheduler - ") + new Date().toLocaleString() + ".csv";
      var skinny = [];
      this.tableItems.forEach(i => {
        console.log(i);
        skinny.push(this.wrapTableItem(i));
      });
      var csv = this.convertArrayOfObjectsToCSV({
        data: skinny,
      });
      console.log("GOt CSV", csv);
      if (csv == null) return;

      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      var link = document.createElement("a");
      document.body.appendChild(link);
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
      document.body.removeChild(link);
      console.log("CLICKED!");
      this.exportDialog = false;
    },
    clearFilters() {
      this.selectedTeams = this.scheduleTeams;
      this.selectedSurfaces = this.scheduleSurfaces;
      this.selectedDivisions = this.scheduleDivisions;
      this.selectedVenues = this.scheduleVenues;

      this.columns = [
        {
          field: "date",
          header: this.$t("GameTable.column.date"),
          sortField: "sortDate",
          sortable: true,
          frozen: true,
        },
        { field: "weekday", header: this.$t("GameTable.column.day"), sortable: false, frozen: true },
        { field: "time", header: this.$t("GameTable.column.start"), sortable: false, frozen: true },
        { field: "finishTime", header: this.$t("GameTable.column.finish"), sortable: false, frozen: true },
        { field: "visitor.name", header: this.$t("GameTable.column.visitor"), sortable: false, frozen: true },
        { field: "home.name", header: this.$t("GameTable.column.home"), sortable: false, frozen: true },
        { field: "venue.name", header: this.$t("GameTable.column.venue"), sortable: false, frozen: true },
        { field: "surface.name", header: this.$t("GameTable.column.surface"), sortable: false, frozen: true },
        { field: "game_score", header: this.$t("GameTable.column.game-score"), sortable: false, frozen: true },
        {
          field: "updated_at",
          header: this.$t("GameTable.column.last-edited"),
          sortField: "update_sort",
          sortable: true,
          frozen: true,
        },
        {
          field: "visitor.division.name",
          header: this.$t("GameTable.column.visitor-division"),
          sortable: false,
          frozen: true,
        },
        {
          field: "home.division.name",
          header: this.$t("GameTable.column.home-division"),
          sortable: false,
          frozen: true,
        },
      ];

      if (this.schedule.is_practice) {
        this.columns = [
          {
            field: "date",
            header: this.$t("GameTable.column.date"),
            sortField: "sortDate",
            sortable: true,
            frozen: true,
          },
          { field: "weekday", header: this.$t("GameTable.column.day"), sortable: false, frozen: true },
          { field: "time", header: this.$t("GameTable.column.time"), sortable: false, frozen: true },
          { field: "home.name", header: this.$t("GameTable.column.team"), sortable: false, frozen: true },
          { field: "venue.name", header: this.$t("GameTable.column.venue"), sortable: false, frozen: true },
          { field: "surface.name", header: this.$t("GameTable.column.surface"), sortable: false, frozen: true },
        ];
      }

      var z = 10;
      if (this.schedule && this.schedule.division && this.schedule.division.is_across) {
        z = 12;
      }
      this.selectedColumns = this.columns.slice(0, z);
    },
    rowClass(data) {
      return data.blocked ? "blur" : null;
    },
    startEditGame() {
      if (this.selectedItems[0].blocked) {
        this.makeToast("info", this.$t("Toast.upgrade-account-to-access-hidden-game"));
        return;
      }
      this.activeGame = this.selectedItems[0];
      this.gameModal = true;
    },
    updateItems(items) {
      console.log("🔴 Updated Items", items);
      this.$emit("update", items);
      this.closeModals();
    },
    updated(item) {
      console.log("🥏 Update", item);
      var items = this.schedule.scheduled_items;
      var found = false;
      items.forEach((e, i) => {
        if (!found && e.id == item.id) {
          console.log("🧡 Game at " + i);
          found = true;
          items.splice(i, 1);
          items.push(this.formatItem(item));
        }
      });
      if (!found) {
        this.openTimeslots.forEach((t, i) => {
          console.log(t.id, item.id, t.id == item.id);
          if (!found && t.id == item.id) {
            console.log("🧡 Timeslot at " + i);
            console.log("Original: " + this.openTimeslots.length);
            var z = this.formatTimeslot(item);
            console.log("Formatted", z);
            this.openTimeslots.splice(i, 1);
            console.log("Spliced Length: " + this.openTimeslots.length);
            this.openTimeslots.push(z);
            console.log("New Length: " + this.openTimeslots.length);
          }
        });
      }
      this.closeModals();
    },
    close() {
      console.log("Close Modals");
      this.selectedItems = [];
      this.activeEvent = null;
      this.activeGame = null;
      this.gameModal = false;
      this.editModal = false;
      this.scoresModal = false;
    },
    refresh(a, b) {
      console.log("REFRESH", a, b);
      this.clearModal();
      this.editModal = false;
      this.scoresModal = false;
      this.selectedItems = [];
      this.activeGame = null;
      this.$emit("refresh");
      this.$forceUpdate();
    },
    // onToggle(value) {
    //   this.selectedColumns = this.columns.filter((col) => value.includes(col));
    // },
    exportTable() {
      window.analytics.track("Exported Table", {
        url: window.location.href,
      });
      this.$refs.gamesTable.exportCSV();
      this.exportDialog = false;
    },
    printTable() {
      this.printing = true;
      // if (this.schedule.is_practice) {
      //   this.selectedColumns = this.columns.slice(0,7)
      // } else {
      //   this.selectedColumns = this.columns.slice(0,8)
      // }
      setTimeout(() => {
        this.$htmlToPaper("gamesTable", null, () => {
          console.log("Printing completed or was cancelled!");
          this.printing = false;
          this.exportDialog = false;
        });
      }, 250);
    },
    displayCoachConflict(conflict) {
      if (conflict.teamIds) {
        const teamNames = [];
        conflict.teamIds.forEach(teamId => {
          const team = this.schedule.teams.find(t => t.id === teamId);
          teamNames.push(team.name);
        });
        return `Coach ${conflict.coach_name} has overlapping teams: ${teamNames.join(", ")}`;
      } else if (conflict.date) {
        return `Coach ${conflict.coach_name} has overlapping games on: ${this.$moment(conflict.date).format("LLL")}`;
      }
    },
  },
  created() {
    this.clearFilters();
    console.log("🔱 GameTable Schedule", this.schedule);
    // this.showOpen = this.schedule.unscheduled_items.length > 0
    var team_id = this.getURLParam("team_id");
    var venue_id = this.getURLParam("venue_id");
    var division_id = this.getURLParam("division_id");
    var surface_id = this.getURLParam("surface_id");
    if (team_id) {
      this.selectedTeams = [team_id];
    } else {
      this.selectedTeams = this.scheduleTeams;
    }
    if (surface_id) {
      this.selectedSurfaces = [surface_id];
    } else {
      this.selectedSurfaces = this.scheduleSurfaces;
    }
    if (venue_id) {
      this.selectedVenues = [venue_id];
    } else {
      this.selectedVenues = this.scheduleVenues;
    }
    if (division_id) {
      this.selectedDivisions = [division_id];
    } else {
      this.selectedDivisions = this.scheduleDivisions;
    }
  },
};
</script>
<template>
  <div>
    <GameModal
      :master="master"
      :teams="gameTeams"
      :active="gameModal"
      :input="activeGame"
      :schedule="schedule"
      v-on:hide="clearModal"
      v-on:refresh="refresh"
      v-on:updated="updateItems"
      v-on:gamecreated="gameCreated"
      v-on:deletegame="gameDeleted"
      v-on:unschedulegame="gameUnscheduled"
    ></GameModal>
    <MultiGameModal
      :active="editModal"
      :input="selectedItems"
      v-on:hide="editModal = false"
      v-on:refresh="refresh"
    ></MultiGameModal>
    <GameScoresModal
      :active="scoresModal"
      :input="selectedItems"
      v-on:hide="scoresModal = false"
      v-on:refresh="refresh"
      :schedule="schedule"
      :refreshSchedule="refreshSchedule"
    ></GameScoresModal>
    <TournamnetBracket
      :active="bracketDialog"
      :items="schedule.scheduled_items"
      :close="() => (bracketDialog = false)"
      :schedule="schedule"
    />
    <DataTable
      exportFilename="'Interviews'"
      :reorderableColumns="true"
      :scrollable="true"
      :scrollHeight="showFilters ? '50vh' : '70vh'"
      :rowClass="rowClass"
      :value="tableItems"
      selectionMode="multiple"
      :metaKeySelection="false"
      :filters="filters"
      :class="{ scrollTable: showFilters }"
      :sortOrder="-1"
      ref="gamesTable"
      :selection.sync="selectedItems"
      dataKey="id"
      id="gamesTable"
      class="p-datatable-sm p-datatable-striped whiteBg"
    >
      <template #header v-if="!unscheduled" class="whiteBg">
        <div v-if="printing" style="display: flex; padding: 30px 0px;">
          <div style="width: 70%">
            <h1 class="title is-3">{{ schedule.name }}</h1>
          </div>
          <div style="width: 30%">
            <img
              @click="printing = false"
              style="width: 100%; margin: 0 auto"
              src="https://diamond-public.s3.us-west-2.amazonaws.com/assets/diamond-logo-white.png"
            />
          </div>
        </div>

        <div class="p-grid whiteBg" v-if="!printing">
          <div class="whiteBg p-col-12" style="pointer-events: auto !important; user-select: auto !important">
            <span class="font-weight: normal;" style="font-size: 1.25em" @click="debug">
              {{ $t("click-a-row-to-select-one-or-more-items-use-shift-key") }}</span
            >
            <!-- <div v-if="!isProduction && selectedItems.length" style="pointer-events: auto !important; user-select: auto !important">
              {{ selectedItems }}
            </div> -->
          </div>
          <div v-if="selectedItems.length" class="p-col-12">
            <span class="tableHeader"> Selected: {{ selectedItems.length }} </span>
            <span v-if="selectedItems.length">
              <Button
                v-if="selectedItems.length > 1"
                :label="$t('Button.edit')"
                @click="editModal = true"
                class="p-ml-3 p-button-outlined"
              ></Button>
              <Button
                v-else
                :label="$t('Button.edit')"
                @click="startEditGame"
                class="p-ml-3 p-button-outlined"
              ></Button>
              <Button
                v-if="selectedItems.length == 2"
                :label="$t('Button.swap-timeslots')"
                @click="swapTimeslots"
                class="p-ml-3 p-button-outlined p-button-secondary"
              ></Button>
              <Button
                :label="$t('Button.unschedule')"
                @click="startRemove(false)"
                class="p-ml-3 p-button-outlined p-button-help"
              ></Button>
              <Button
                :label="$t('Button.score-games')"
                @click="scoresModal = true"
                class="p-ml-3 p-button-outlined p-button-success"
              ></Button>
              <Button
                :label="$t('Button.delete')"
                @click="startRemove(true)"
                class="p-ml-3 p-button-outlined p-button-danger"
              ></Button>
              <Button
                v-if="selectedItems.length > 1"
                :label="$t('Button.clear-selection')"
                @click="selectedItems = []"
                class="p-ml-3 p-button-text"
              ></Button>
            </span>
          </div>
          <div v-if="!selectedItems.length || showFilters" class="p-col-12" style="padding: 0">
            <Button class="p-button-sm p-button-secondary" @click="showFilters = !showFilters">
              <font-awesome-icon
                style="font-size: 1em"
                :icon="showFilters ? ['fal', 'angle-up'] : ['fal', 'angle-down']"
              />
              {{ $t("Button.filters") }}
            </Button>
            &nbsp;
            <Button class="p-button-sm p-button-secondary" @click="toggleShowOpen">
              {{ showOpen ? $t("Button.hideTimeslotsButton") : $t("Button.showTimeslots") }} </Button
            >&nbsp;
            <Button class="p-button-sm p-button-secondary" v-if="!master" @click="gameModal = true">
              {{ $t("Button.create-game") }}
            </Button>
            &nbsp;
            <Button class="p-button-sm p-button-secondary" @click="checkConflicts">
              {{ $t("Button.check-conflicts") }}
            </Button>
            &nbsp;
            <Button class="p-button-sm p-button-secondary" @click="doBalances">
              {{ $t("Button.show-balances") }}
            </Button>
            &nbsp;
            <Button class="p-button-sm p-button-secondary" @click="exportDialog = true">
              {{ $t("Button.export") }}
            </Button>

            <Button
              class="p-button-sm p-button-secondary ml-3"
              v-if="schedule && schedule.config && schedule.config.is_tournament"
              @click="bracketDialog = true"
            >
              {{ $t("Button.view-bracket") }}
            </Button>

            <Dialog
              :show-header="false"
              :visible="exportDialog"
              :style="{ maxWidth: '90%', width: '800px' }"
              :modal="true"
              :closable="false"
            >
              <div class="p-py-4 p-text-center">
                <div class="title is-3">{{ $t("Button.export-schedule") }}</div>
                <div v-if="!master && seConnected && currentSeason.se_id">
                  <Button
                    class="p-button p-button-secondary"
                    style="background: white; color: inherit"
                    @click="exportSchedule(schedule)"
                    >Sync to
                    <img
                      src="/se_logo_full.png"
                      style="
                            height: 1em;
                            margin-top: 5px;
                            vertical-align: middle;
                            margin-left: 5px;
                          "
                    />
                  </Button>
                  <br />
                </div>
                <br />
                &nbsp;
                <Button class="p-button p-button-primary p-button-lg" @click="printTable">{{
                  $t("Button.print-table")
                }}</Button>
                &nbsp;
                <Button class="p-button p-button-primary p-button-lg" @click="downloadCSV">{{
                  $t("Button.download-csv")
                }}</Button>
                <br /><br />
                <Button class="p-button p-button-primary p-button-lg" @click="doDbd">
                  {{ $t("Button.day-by-day-table") }}</Button
                >
                &nbsp;
                <Button class="p-button p-button-primary p-button-lg" @click="perTeamCSV">{{
                  $t("Button.per-team-csv")
                }}</Button>
                <br /><br /><br />
                <div class="title is-5">{{ $t("Button.platform-specific-csvs") }}</div>
                <Button class="p-button p-button-secondary" @click="leagueAppsCSV">LeagueApps </Button>
                &nbsp;
                <Button class="p-button p-button-secondary" @click="SeCSV">SportsEngine </Button>
                &nbsp;
                <Button class="p-button p-button-secondary" @click="downloadLACSV">LeagueAthletics </Button>
                &nbsp;
                <Button class="p-button p-button-secondary" @click="pointstreakCSV">PointStreak </Button>
                &nbsp;
                <br /><br />
                <Button class="p-button p-button-secondary" @click="downloadSombreroCSV">BlueSombrero </Button>
                &nbsp;
                <Button class="p-button p-button-secondary" @click="teamSnapCSV">TeamSnap </Button>
                &nbsp;
                <Button class="p-button p-button-secondary" @click="downloadArbiterCSV">Arbiter </Button>
                &nbsp;
                <Button class="p-button p-button-secondary" @click="goCSV">GoalOnline </Button>

                <br /><br />
                <Button class="p-button p-button-secondary" @click="rampCSV">
                  RAMP Interactive
                </Button>
                &nbsp;
                <Button class="p-button p-button-secondary" @click="seSeasonManagement">
                  SportsEngine Season
                  <br />
                  Management BETA
                </Button>
                &nbsp;
                <br /><br />
                <Button class="p-button p-button-text" @click="exportDialog = false">{{ $t("Button.done") }}</Button>
              </div>
            </Dialog>
            <Dialog
              :show-header="false"
              :visible="conflictDialog"
              :style="{ maxWidth: '90%', width: '800px' }"
              :modal="true"
              :closable="false"
            >
              <div class="p-py-4 p-text-center">
                <div class="title is-3">{{ $t("conflicts") }}</div>
                <div v-if="conflicts">
                  <div>
                    <br />
                    <div class="title is-5" v-if="conflicts.surfaces.length">
                      {{ $t("surface-conflicts", [conflicts.surface_conflicts]) }}
                    </div>
                    <div class="title is-5" v-else>{{ $t("no-surface-conflicts") }}</div>
                    <div v-for="conflict in conflicts.surfaces">
                      {{
                        $t("conflict-name-has-overlapping-games-on-moment", [
                          conflict.name,
                          $moment(conflict.date).format("LLL"),
                        ])
                      }}
                      <br />
                    </div>
                  </div>
                  <br />

                  <div>
                    <div class="title is-5" v-if="conflicts.team_conflicts > 0">
                      {{ $t("team-conflicts", [conflicts.team_conflicts]) }}
                    </div>
                    <div class="title is-5" v-else>{{ $t("no-team-conflicts") }}</div>
                    <div v-for="conflict in conflicts.teams">
                      {{
                        $t("conflict-name-has-overlapping-games-on-moment", [
                          conflict.name,
                          $moment(conflict.date).format("LLL"),
                        ])
                      }}
                      <br />
                    </div>
                    <div v-for="conflict in conflicts.teams_weeks">
                      {{
                        $t("conflict-name-has-conflict-count-games-in-week", [
                          conflict.name,
                          conflict.count,
                          $moment(conflict.date).format("L"),
                          conflict.max_games,
                        ])
                      }}
                      <br />
                    </div>
                    <div v-for="conflict in conflicts.teams_time">
                      {{
                        $t("conflict-name-has-time-conflicts", [conflict.name, $moment(conflict.date).format("LLL")])
                      }}
                      <br />
                      <small class="has-text-grey">--{{ conflict.note }}</small>
                      <br />
                    </div>
                  </div>
                  <br />

                  <div>
                    <div class="title is-5" v-if="conflicts.coach_conflicts.length > 0">
                      {{ $t("coach-conflicts", [conflicts.coach_conflicts.length]) }}
                    </div>
                    <div class="title is-5" v-else>{{ $t("no-coach-conflicts") }}</div>
                    <div v-for="conflict in conflicts.coach_conflicts">
                      - {{ displayCoachConflict(conflict) }}
                      <br />
                    </div>
                  </div>
                </div>
                <div v-else>
                  <ProgressSpinner />
                </div>
                <br /><br />
                <Button class="p-button p-button-text" @click="conflictDialog = false">{{ $t("Button.done") }}</Button>
              </div>
            </Dialog>
          </div>
          <br /><br />
        </div>
        <div v-if="showFilters && !printing" class="p-grid" id="filterBox">
          <div class="title is-4 p-col p-col-12">
            &nbsp; {{ $t("filters") }} &nbsp;
            <Button style="float: right" class="p-button p-button-secondary" @click="clearFilters">{{
              $t("Button.reset-filters")
            }}</Button>
          </div>
          <div class="p-col p-col-2">
            <div class="title is-5">
              {{ $t("Division.divisions") }}
              <Button
                class="p-button-text p-button-sm inlineButton"
                :label="$t('Button.toggle')"
                @click="toggleDivisions"
              />
            </div>
            <div class="p-field-checkbox" v-for="t in filterDivisions" :key="t.id">
              <Checkbox :id="t.name" :name="t.name" :value="t.id" v-model="selectedDivisions" />
              <label :for="t.name">{{ t.name }} </label>
            </div>
          </div>
          <div class="p-col p-col-4">
            <div class="title is-5">
              {{ $t("Team.teams") }}
              <Button
                class="p-button-text p-button-sm inlineButton"
                :label="$t('Button.toggle')"
                @click="toggleTeams"
              />
            </div>
            <div class="p-grid">
              <div class="p-col-6">
                <div
                  class="p-field-checkbox"
                  v-for="t in halfTeams.a"
                  :key="t.id"
                  v-show="selectedDivisions.includes(t.division_id)"
                >
                  <Checkbox :id="t.name" :name="t.name" :value="t.id" v-model="selectedTeams" />
                  <label :for="t.name">{{ t.name }} </label>
                </div>
              </div>
              <div class="p-col-6">
                <div
                  class="p-field-checkbox"
                  v-for="t in halfTeams.b"
                  :key="t.id"
                  v-show="selectedDivisions.includes(t.division_id)"
                >
                  <Checkbox :id="t.name" :name="t.name" :value="t.id" v-model="selectedTeams" />
                  <label :for="t.name">{{ t.name }} </label>
                </div>
              </div>
            </div>
          </div>
          <div class="p-col p-col-3">
            <div class="title is-5">
              {{ $t("Venue.venues") }}
              <Button
                class="p-button-text p-button-sm inlineButton"
                :label="$t('Button.toggle')"
                @click="toggleVenues"
              />
            </div>
            <div class="p-field-checkbox" v-for="t in filterVenues" :key="t.id">
              <Checkbox :id="t.name" :name="t.name" :value="t.id" v-model="selectedVenues" />
              <label :for="t.name">{{ t.name }} </label>
            </div>
            <div class="title is-5">
              {{ $t('playing-surfaces') }}
              <Button
                class="p-button-text p-button-sm inlineButton"
                :label="$t('Button.toggle')"
                @click="toggleSurfaces"
              />
            </div>
            <div class="p-field-checkbox" v-for="t in filterSurfaces" :key="t.id">
              <Checkbox :id="t.name" :name="t.name" :value="t.id" v-model="selectedSurfaces" />
              <label :for="t.name"
                >{{ t.name }}
                <span v-if="selectedVenues.length > 1 && t.name.includes('Surface')" style="font-size: 0.7em"
                  >({{ t.venue.name }})</span
                >
              </label>
            </div>
          </div>
          <div class="p-col p-col-3">
            <div class="title is-5">{{ $t("columns") }}</div>
            <div class="p-grid">
              <div class="p-col-6">
                <div class="p-field-checkbox" v-for="t in halfColumns.a" :key="t.header">
                  <Checkbox :id="t" :name="t" :value="t" v-model="selectedColumns" />
                  <label :for="t">{{ t.header }} </label>
                </div>
              </div>
              <div class="p-col-6">
                <div class="p-field-checkbox" v-for="t in halfColumns.b" :key="t.header">
                  <Checkbox :id="t" :name="t" :value="t" v-model="selectedColumns" />
                  <label :for="t">{{ t.header }} </label>
                </div>
              </div>
            </div>
          </div>
          <div class="p-col-12 p-text-center">
            <p v-if="!showOpen">
              {{ $t("filtered-results-tableitems", [tableItems.length, schedule.scheduled_items.length]) }}
            </p>
            <p v-else>
              {{
                $t("filtered-results-tableitems", [
                  tableItems.length,
                  schedule.scheduled_items.length + openTimeslots.length,
                ])
              }}
            </p>
          </div>
        </div>
      </template>
      <!-- <Column
        v-if="!printing"
        selectionMode="multiple"
        headerStyle="width: 3em"
      ></Column> -->
      <Column
        v-for="(col, index) of selectedColumns"
        :field="col.field"
        :header="col.header"
        :key="col.field + '_' + index"
        :sortable="col.sortable"
        :sortField="col.sortField || col.field"
      ></Column>
    </DataTable>
    <div v-if="!schedule.scheduled_items.length" style="background: white; padding: 30px; text-align: center">
      {{ $t("no-games-to-display") }}
      <!-- <div v-if="true || !schedule.id">
        <br /><br />
        <Button
          @click="goRouter('/schedules/new')"
          label="Create New Schedule"
        />
      </div> -->
    </div>
    <div v-else-if="!tableItems.length" style="background: white; padding: 30px">
      {{ $t("no-games-to-display") }}
      <br /><br />
      <Button @click="clearFilters" :label="$t('Butoon.clear-filters')" />
    </div>
  </div>
</template>
<style>
#gamesTable {
  border-radius: 10px;
}
.p-datatable-header {
  background: white !important;
  border: none !important;
}
</style>
<style scoped lang="scss">
.inlineButton {
  padding: 0px 5px 2px 5px !important;
}
</style>
<style lang="scss">
.tableHeader {
  // margin-bottom: 5px;
  font-size: 1.5em;
  margin: 5px 10px;
}
#filterBox {
  label {
    // font-weight: normal !important;
    line-height: 1.25em;
  }
  background: lightyellow;
  border: 2px solid grey;
  border-radius: 10px;
  padding: 10px 15px;
  width: 100%;
  .p-inputtext {
    font-size: 14px !important;
  }
  margin: 15px 0px;
  margin-left: 0px;
}
</style>
